<template>
    <v-card style="height: 100%; max-height: 100%;  overflow-y: auto" class="ma-0 pa-0" flat>
      <v-row class="ma-0 pa-0" style="width: 100%;" align="center">
        <v-col cols="auto" align="center" justify="center">
          <span class="report-subtitle">Share of Search</span>
        </v-col>
        <v-spacer></v-spacer>
        <v-col cols="auto" align="center" justify="center">
          <v-btn disabled icon>
            <v-icon color="black">mdi-cog</v-icon>
          </v-btn>
        </v-col>
        <v-col cols="12" class="ma-0 pa-0" style="height: 10px;">
          <v-divider class="mx-12"></v-divider>
        </v-col>
        <v-col cols="12" v-if="!graph_visible">
          <v-skeleton-loader
                      light
                      :style="{
                        height: screenHeight + 'px',
                      }"
                      type="image,image,image,image"
            ></v-skeleton-loader>
        </v-col>
        <v-col v-if="graph_visible" class="ma-0 pa-0">
            <v-row class="ma-0 pa-0" style="height: 90%">
              <v-col cols="12" class="chartAlign">
                  <v-chart
                    :option="sos_chart_data"
                    :ref="chart_ref"
                    :key="chart_update_key"
                    autoresize
                  >
                  </v-chart>
              </v-col>
            </v-row>
          </v-col>
      </v-row>
    </v-card>
  </template>
  
  <script>
  import VChart, { THEME_KEY } from 'vue-echarts';
  import "echarts";
  import { use } from 'echarts/core';
  import { CanvasRenderer } from 'echarts/renderers';
  import {
      TitleComponent,
      TooltipComponent,
      LegendComponent,
  } from 'echarts/components';

  use([
      CanvasRenderer,
      TitleComponent,
      TooltipComponent,
      LegendComponent,
  ]);
    
  // Configs
  // import cpalette from "@/configs/ChartColors/get_color_palette.js";
  
  export default {
    name: "ShareOfSearch",
    props: [
      'data_version',
      'dataset',
      'color_palette',
      'available_adunits',
      'chart_ref',
      'chart_update_key'
    ],
    components: {
      VChart
    },
    provide: {
      [THEME_KEY]: 'light',
    },
    data: () => ({
      filter_menu: false,
      graph_visible: false,
      graph_data: null,
      screenHeight: window.innerHeight * 0.7,

      selected_adunits: [],
      adunit_updates: 0
    }),
    mounted() {
      this.graph_data = this.dataset;
      if(this.dataset != null){
        this.reload_graph();
      }
    },
    watch: {
      dataset: {
        immediate: false,
        handler: function () {
          this.graph_data = this.dataset;
          if(this.dataset != null){
            this.reload_graph();
          }
        },
        deep: true,
      },
      selected_adunits: {
        immediate: false,
        handler: function () {
          this.adunit_updates += 1;
          setTimeout(() => {
            this.adunit_updates -= 1; 
            if(this.adunit_updates == 0){
              this.$emit('ve_levels', this.selected_adunits);
            }
          }, 2000);
        },
      },
      available_adunits: {
        immediate: false,
        handler: function () {
          this.selected_adunits = this.available_adunits;
        },
      }
    },
    computed: {
      sos_chart_data: function() {
          let dataset = this.graph_data;
          let data_category = [];
          let data_series = [];
          let data = [];
          let series = [];
          if (dataset != null) {
            data = Array.from(Array(dataset[0].length - 1), () => []);
            data_series = dataset[0];
            data_series.shift();

            for (let i = 1; i < dataset.length; i++) {
              data_category.push(dataset[i][0]);

              for (let j = 1; j < dataset[i].length; j++) {
                data[j - 1].push(dataset[i][j]);
              }
            }

            for (let idx = 0; idx < data.length; idx++) {
              series.push({
                name: data_series[idx],
                type: "line",
                data: data[idx],
                emphasis: {
                  focus: "series",
                },
              });
            }
          }

          const option = {
            tooltip: {
              trigger: "axis",
            },
            legend: {
              data: data_series,
              type: "scroll"
            },
            grid: {
              left: "3%",
              right: "4%",
              bottom: "3%",
              containLabel: true,
            },
            xAxis: [
              {
                type: "category",
                data: data_category,
                axisTick: {
                  alignWithLabel: true,
                },
                axisLabel: {
                  fontSize: 18,
                  fontFamily: "Poppins",
                },
              },
            ],
            yAxis: [
              {
                type: "value",
                axisLabel: {
                  fontSize: 18,
                  fontFamily: "Poppins",
                },
              },
            ],
            series: series,
            // color: COLOR_PALETTE,
          };
          console.log("portfolio_sos_data")
          console.log(this.portfolio_sos_data)
          console.log("option")
          console.log(option)
          return option;
      }
    },
    methods: {
      reload_graph: function () {
        this.graph_visible = false;
        setTimeout(() => (this.graph_visible = true), 10);
      },
    },
  };
  </script>
  
  <style scoped>
    .report-subtitle {
      font-family: "Poppins";
      font-weight: 500;
      font-size: 1.5em;
    }
    .chartAlign {
      margin: auto 0
    }
  </style>
  
